import { h, Component } from 'preact'
import { connect } from 'react-redux'
import reduce from '../reducers'
import * as actions from '../actions'
import constants from '../constants'

import Renderer from '../canvas/renderer'
import { DownOutlined } from '@ant-design/icons'

export default @connect(reduce, actions)
class FlipWidget extends Component {
  constructor() {
    super()

    this.flipHorizontally = () => {
      this.transformElement(this.props.verticalFlip, !this.props.horizontalFlip)
      this.props.flipHorizontally()
    }

    this.flipVertically = () => {
      this.transformElement(!this.props.verticalFlip, this.props.horizontalFlip)
      this.props.flipVertically()
    }

    this.transformElement = (verticalFlip, horizontalFlip) => {
      Renderer.transformElement(this.props.$element,
        verticalFlip,
        horizontalFlip,
        this.props.rotationDeg,
        this.props.scale)
    }
  }

  render(props, state) {
    return (
      <div class={`dropdown ${props.isMobileVersion ? 'flip-widget' : ''}`}>
        <a class={`dropdown-toggle ${!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'}`} data-hint="Flip">
          <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-flip"} /></svg>
          {props.isMobileVersion && <span>Flip</span>}
        </a>
        <div class="dropdown-menu">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Flip</span>
            <div className="dropdown-toggle"><DownOutlined/></div>
          </div>}

          <div class="angle left"></div>
          <div>
            <ul className={props.isMobileVersion ? 'mobile-two-column' : ''}>
              <li className={props.isMobileVersion ? 'mobile-column' : ''}>
                <a onClick={this.flipHorizontally} className="flip-button">
                  <svg class="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-flip"} /></svg>
                  <span>Flip Horizontally</span>
                </a>
              </li>
              <li className={props.isMobileVersion ? 'mobile-column' : ''}>
                <a onClick={this.flipVertically} className="flip-button">
                  <svg class="icn rotate-90"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-flip"} /></svg>
                  <span>Flip Vertically</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
